import { Box } from '@qga/roo-ui/components';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import { border, display, height, margin, themeGet, width } from 'styled-system';

const pulse = keyframes`
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
`;

const PulsingLoadingBlock = styled(Box)`
  ${display};
  ${height};
  ${width};
  ${margin};
  ${border};
  animation: ${pulse} 2s ease-in-out infinite;
  background-color: ${themeGet('colors.greys.alto')};
`;

PulsingLoadingBlock.propTypes = {
  ...display.propTypes,
  ...height.propTypes.isRequired,
  ...width.propTypes.isRequired,
  ...margin.propTypes,
  ...height.propTypes,
  ...border.propTypes,
};

PulsingLoadingBlock.defaultProps = {
  mb: 2,
  mr: 2,
  mt: 0,
  ml: 0,
  borderRadius: 10,
  display: 'block',
};

export default PulsingLoadingBlock;
